<template>
  <JjigaeBody />
</template>

<script>
import JjigaeBody from '../molecules/JjigaeBody.vue'


export default {
  name: 'JjigaeView',
  components: {
    JjigaeBody,
  }
}
</script>
